import { Flex, Space, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import ButtonComponent from "../../../../Components/Button"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import { dateFormat } from "../../../../Utils/utils"

dayjs.extend(utc)

const { Text } = Typography

export const getColumns = ({ onSelectRow }) => {
  const handleAction = (e, data, type) => {
    e.preventDefault()
    e.stopPropagation()
    onSelectRow(data, type)
  }
  return [
    {
      key: "campaign",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Campaign",
          sorter: true,
          stateData: state,
          key: "campaign"
        }),
      dataIndex: "campaign"
    },
    {
      key: "source",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Source",
          sorter: true,
          stateData: state,
          key: "source"
        }),
      dataIndex: "source"
    },
    {
      key: "link",
      title: (state) =>
        titleSortFilters({
          title: "Link",
          stateData: state,
          key: "link"
        }),
      dataIndex: "link",
      render: (_) => (
        <Flex gap={4}>
          <Text copyable={{ tooltips: false, text: _ }} />
          <a href={_} target="_blank" onClick={(e) => e.stopPropagation()} rel="noreferrer">
            {_}
          </a>
        </Flex>
      )
    },
    {
      key: "user_qty",
      title: (state) =>
        titleSortFilters({
          title: "Users",
          stateData: state,
          key: "user_qty"
        }),
      dataIndex: "user_qty",
      width: 200,
      render: (_, record) =>
        _ ? (
          <ButtonComponent
            type="link"
            onClick={(e) => handleAction(e, record, "view_users")}
            className="flex center "
            style={{ padding: 0 }}
          >
            {_}
          </ButtonComponent>
        ) : (
          "0"
        )
    }
  ]
}

export const columns = [
  {
    key: "name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Name",
        sorter: true,
        stateData: state,
        key: "name"
      }),
    dataIndex: "name"
  },
  {
    key: "code_name",
    title: (state) =>
      titleSortFilters({
        title: "Code name",
        stateData: state,
        key: "code_name"
      }),
    dataIndex: "code_name"
  }
]

export const linkUsersColumns = [
  {
    key: "user_full_name",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "User name",
        sorter: true,
        stateData: state,
        key: "user_full_name"
      }),
    dataIndex: "user_full_name"
  },
  {
    key: "email",
    sorter: true,
    title: (state) =>
      titleSortFilters({
        title: "Email",
        sorter: true,
        stateData: state,
        key: "email"
      }),
    dataIndex: "email"
  },
  {
    key: "created",
    title: (state) =>
      titleSortFilters({
        title: "Account creation date",
        stateData: state,
        key: "created"
      }),
    dataIndex: "created",
    //width: 185,
    render: (_) => (
      <Space direction="vertical" size={4}>
        <Text>{dayjs(_).format(dateFormat)}</Text>
        {/* <Text type="secondary">{dayjs(_).format('h:mm A [(UTC)]')}</Text>*/}
      </Space>
    )
  },
  {
    key: "alerts_qty",
    title: (state) =>
      titleSortFilters({
        title: "Alerts",
        stateData: state,
        key: "alerts_qty"
      }),
    //width: 185,
    dataIndex: "alerts_qty",
    render: (_) => _ || "—"
  }
]
